import { CorridorLevel, TerminalLevel } from '../../models/train-info.model';
import { IOHAppService } from '../../services/ioh-app.service';
import {
  Component,
  effect,
  input,
  output,
  ViewChild,
  ElementRef,
  Renderer2,
  signal,
  untracked,
  ChangeDetectorRef,
  Input
} from '@angular/core';
import {
  tableArrowDirectionClass,
  nearByTrainPosistionInfo,
  nearByTrainPosistionTable
} from 'src/app/constants/ioh-train-table-contant';
import { MenuItem, MessageService } from 'primeng/api';
import { IOHMapService } from 'src/app/services/ioh-map.service';
import { IOHSetLevelValueService } from 'src/app/shared/service/ioh-set-level.service';
import { IOHDeviceDetectorService } from 'src/app/shared/service/ioh-device-detector.service';
import { DeviceType } from 'src/app/models/device-detector.enum';
import { ActivatedRoute } from '@angular/router';
import { IOHDynamicDialogService } from 'src/app/shared/service/ioh-dialog.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ContextMenuModule } from 'primeng/contextmenu';
import { IohTerminalEquipmentComponent } from 'src/app/shared/ioh-terminal-equipment/ioh-csx-terminal-equipment.component';
import { IOHLevelOneSvgComponent } from './ioh-level-one-svg.component';
import { IOHLevelTwoSvgComponent } from './ioh-level-two-svg.component';
import { IOHTrainsTableComponent } from 'src/app/shared/ioh-trains-table/ioh-trains-table.component';
import { ToastModule } from 'primeng/toast';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { ButtonModule } from 'primeng/button';
import { toSignal } from '@angular/core/rxjs-interop';
import { IohTerminalGateComponent } from 'src/app/shared/ioh-terminal-gate/ioh-csx-terminal-gate.component';
import { DraggableDirective } from 'src/app/shared/directive/drag-directive';
import { IohTerminalTrainComponent } from 'src/app/shared/ioh-terminal-train/ioh-csx-terminal-train.component';
import { environment } from 'src/environments/environment';
import { IohLevelOneDashboardComponent } from './ioh-level-one-dashboard/ioh-level-one-dashboard.component';

@Component({
  selector: 'ioh-csx-level',
  templateUrl: './ioh-level.component.html',
  styleUrls: ['./ioh-level.component.scss'],
  imports: [
    CommonModule,
    SelectButtonModule,
    ToggleSwitch,
    FormsModule,
    ContextMenuModule,
    IohTerminalEquipmentComponent,
    IohTerminalGateComponent,
    IohTerminalTrainComponent,
    IOHLevelOneSvgComponent,
    IOHLevelTwoSvgComponent,
    IOHTrainsTableComponent,
    ToastModule,
    ButtonModule,
    DraggableDirective,
    IohLevelOneDashboardComponent
  ]
})
export class IOHLevelComponent {
  @Input({ required: true }) level = 0;
  iohShowFilter = input<boolean>(false);
  queryParams = input<any>([]);
  iohSelectedTerminal = input<string>('');
  iohLevelLabel = input<string>('level-1');
  iohLevelLabelChange = output<string>();
  iohTerminalChange = output<any>();
  env = environment;

  _iohSelectedTerminal = signal<string>('');
  corridors = signal<CorridorLevel[]>([]);
  terminals: TerminalLevel[] = [];
  iohCollapseAllData = signal<boolean>(false);
  iohShowCollapseAllBtn = signal<boolean>(false);
  iohActiveTableCount = signal<any[]>([]);
  iohItems = signal<MenuItem[]>([]);
  iohZoomLevel = signal<number>(1);
  miniohZoomLevel = signal<number>(0.5);
  defaultiohZoomLevelForLevel1 = signal<number>(0);
  private isTabletView = signal<boolean>(false);
  iohShowNearByTrainOnQueryIntial = signal<boolean>(true);
  iohTrainIdForSearch = signal<string>('');
  iohLevelValueFromStore = signal<string>('');
  iohDynamicFontSize = signal<any>(null);
  iohTrainLabelsShow = signal<boolean>(false);
  isIohShowLabelSwitchEnabled = signal<boolean>(true);
  routeQueryParams = signal<any>(null);
  iohEquipmentInfo = signal<any[]>([]);
  iohGateInfo = signal<any[]>([]);
  iohTrainInfo = signal<{ [key: string]: any }>({});
  displayEquipmentInfoTableData = signal<any[]>([]);
  iohLevel2InitialScroll = signal<boolean>(true);
  tableArrowDirectionClass = tableArrowDirectionClass;
  nearByTrainPosistionInfo = nearByTrainPosistionInfo;
  nearByTrainPosistionTable = nearByTrainPosistionTable;
  iohStateOptions: any[] = [
    { label: 'Level 1', value: 'level-1', icon: '1' },
    { label: 'Level 2', value: 'level-2', icon: '2' },
    {
      label: 'Map',
      value: 'level-3',
      icon: "'src/assets/ioh/svg/globe-Icon.svg'"
    }
  ];

  @ViewChild('iohNetworkSchematic') iohNetworkSchematic?: ElementRef;
  @ViewChild('iohlevelSchematic') iohlevelSchematic?: ElementRef;
  @ViewChild('iohcm') iohcm?: any;
  @ViewChild('level3MapSlot') level3MapSlot?: ElementRef<HTMLElement>;

  private showTrainLabels = toSignal(this.iohMapService.iohShowTrainLabels$, {
    initialValue: false
  });
  private routeParams = toSignal(this.route.queryParams, { initialValue: {} });

  constructor(
    public iohAppService: IOHAppService,
    private messageService: MessageService,
    public iohMapService: IOHMapService,
    private iohDeviceDetectorService: IOHDeviceDetectorService,
    private iohSetLevelValueService: IOHSetLevelValueService,
    private route: ActivatedRoute,
    public dialogService: IOHDynamicDialogService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) {
    this.checkDeviceType();
    if (this.isTabletView()) {
      this.miniohZoomLevel.set(0.75);
    }
    effect(() => {
      this.routeQueryParams.set(this.routeParams());
      this.iohLevelValueFromStore.set(
        this.iohSetLevelValueService.iohSelectedLevel() as string
      );
      this.iohDynamicFontSize.set(this.iohAppService.iohFontSizeValue$());
      this.iohTrainLabelsShow.set(this.showTrainLabels() as boolean);
      this.iohTrainIdForSearch.set(this.iohAppService.iohIsTrainIdSearch());
    });

    effect(() => {
      const iohTerminalsLevels = this.iohAppService.iohTerminalsLevels$();
      const iohCorridorsLevels = this.iohAppService.iohCorridorsLevel$();
      const level = this.level;
      if (level === 0 || level === 1) {
        if (iohTerminalsLevels && iohTerminalsLevels.length > 0) {
          const openPopupsByUid = new Map(
            this.terminals?.map(terminal => [
              terminal.uid,
              {
                showEquipmentInfo: terminal.showEquipmentInfo,
                showGateInfo: terminal.showGateInfo,
                showTrainInfo: terminal.showTrainInfo,
                showNearByTrains: terminal.showNearByTrains,
                popupClickPoint: terminal.popupClickPoint,
                popupBounds: terminal.popupBounds
              }
            ])
          );
          this.terminals = iohTerminalsLevels[level];
          this.terminals?.forEach(terminal => {
            const openPopups = openPopupsByUid.get(terminal.uid);
            if (openPopups) {
              terminal.showEquipmentInfo = openPopups.showEquipmentInfo;
              terminal.showGateInfo = openPopups.showGateInfo;
              terminal.showTrainInfo = openPopups.showTrainInfo;
              terminal.showNearByTrains = openPopups.showNearByTrains;
              terminal.popupClickPoint = openPopups.popupClickPoint;
              terminal.popupBounds = openPopups.popupBounds;
            }
          });
          const activeTerminal = this.terminals.filter(
            per => per.showNearByTrains === true
          );
          if (activeTerminal?.length > 0) {
            this.iohShowCollapseAllBtn.set(true);
            this.generateContextMenuItem();
          }
          const activeTerminals = this.terminals
            .filter(
              terminal =>
                terminal.showEquipmentInfo && terminal.isUpdatedByFilter
            )
            .map(terminal => terminal.uid);
          if (activeTerminals && activeTerminals?.length > 0) {
            this.terminals?.forEach(terminal => {
              terminal.showEquipmentInfo = false;
            });
            setTimeout(() => {
              this.terminals?.forEach(terimal => {
                if (activeTerminals?.includes(terimal.uid)) {
                  terimal.showEquipmentInfo = true;
                }
              });
            }, 0);
            const filterQueryName = this.queryParams().query?.toLowerCase();
            if (filterQueryName) {
              this.isIohShowLabelSwitchEnabled.set(false);
            }
            if (
              this.iohShowNearByTrainOnQueryIntial() &&
              filterQueryName &&
              this.terminals.length
            ) {
              this.iohShowNearByTrainOnQueryIntial.set(false);
              this.terminals.forEach(item => {
                if (item.nearByTrains.length) {
                  this.showNearByTrains(item);
                }
              });
            }
          }
          if (iohCorridorsLevels && iohCorridorsLevels.length > 0) {
            this.corridors.set(iohCorridorsLevels[level]);
          }
        }
      }
    });

    effect(() => {
      const levelTrigger = this.iohAppService.iohLevelChangeEventTrigger();
      const currentView = this.iohLevelLabel().split('-')[1];
      if (levelTrigger && currentView !== levelTrigger + '') {
        this.onLevelChangeEvent('level-' + levelTrigger);
      }
    });

    effect(() => {
      const res = this.iohAppService.iohEquipmentInfo$() || [];
      const current = untracked(() => this.iohEquipmentInfo());
      this.iohEquipmentInfo.set(
        [...current, ...res].reduce((acc, obj) => {
          const index = acc.findIndex(
            item => item.terminalName === obj.terminalName
          );
          if (index > -1) {
            acc[index] = obj;
          } else {
            acc.push(obj);
          }
          return acc;
        }, [])
      );
      this.iohAppService.iohEquipmentInfoWc$.set(this.iohEquipmentInfo());
    });

    effect(() => {
      const res = this.iohAppService.iohGateInfo$() || [];
      this.iohGateInfo.set(res);
    });

    effect(() => {
      const res = this.iohAppService.iohTrainInfo$() || null;
      this.iohTrainInfo.set(res);
    });

    effect(() => {
      const val = this.iohSelectedTerminal();
      this._iohSelectedTerminal.set(val);
      if (!val) {
        const levelTwoBg = document.querySelector(
          '.level-two-background'
        ) as HTMLElement | null;
        if (levelTwoBg) {
          this.renderer.removeClass(levelTwoBg, 'visibilityHidden');
        }
      }
    });

    effect(() => {
      const showFilter = this.iohShowFilter();
      if (this.iohNetworkSchematic) {
        const scrollTop =
          this.iohNetworkSchematic.nativeElement.parentElement.scrollTop;
        const scrollLeft =
          this.iohNetworkSchematic.nativeElement.parentElement.scrollLeft;
        const offset = showFilter ? 360 : -360;
        this.iohNetworkSchematic.nativeElement.parentElement.scrollTo({
          left: scrollLeft + offset,
          top: scrollTop,
          behavior: 'smooth'
        });
      }
    });

    effect(() => {
      const label = this.iohLevelLabel();
      this.iohSetLevelValueService.updateIohSelectedLevel(
        label.split('level-')[1]
      );
      if (!this.isTabletView() && label === 'level-1' && this.level === 0) {
        setTimeout(()=>this.adjustSvgZoom(),0);
      }
      if (label === 'level-2' && this.iohLevel2InitialScroll()) {
        this.iohlevelSchematic?.nativeElement?.scrollTo({
          top: 275,
          behavior: 'smooth'
        });
        this.iohLevel2InitialScroll.set(false);
      }
      this.updateFontSize();
      const mapReady = this.iohMapService.mapStyleReady();
      if (label === 'level-3' && mapReady && this.iohMapService.map) {
        this.iohMapService.map.resize();
      }
      this.showLabelsBasedOnView();
      this.generateContextMenuItem();
    });

    this.generateContextMenuItem();
  }

  //to check for device type
  checkDeviceType(): void {
    const deviceType = this.iohDeviceDetectorService.detectDeviceType();
    switch (deviceType) {
      case DeviceType.Tablet:
        this.isTabletView.set(true);
        break;
      case DeviceType.Mobile:
        this.isTabletView.set(true);
        break;
      default:
        this.isTabletView.set(false);
    }
  }

  //show train label on map layer at level 3
  showLabelsBasedOnView() {
    if (this.level === 2 && this.iohLevelLabel() === 'level-3') {
      this.showIohTrainLabels();
    }
  }

  //to show train labels on map at zoom level more than 7
  showIohTrainLabels(flag?: boolean) {
    if (!flag && this.iohMapService.iohZoomLevel() >= 7) {
      this.iohTrainLabelsShow.set(true);
      this.iohMapService.iohShowTrainLabels$.next(true);
    }
    this.showLabelsT();
  }

  //appending showlabels in response
  showLabelsT() {
    this.iohMapService.trainsForMap?.features.forEach(feature => {
      if (feature.properties) {
        feature.properties.showLabels = this.iohMapService.showIohTrainLabels;
      }
    });
  }

  //to get level background class
  getLevelBackgroundClass() {
    if (this.level === 0) {
      return 'level-one-background';
    } else if (this.level === 1) {
      return 'level-two-background visibilityHidden';
    }
    return '';
  }

  showNearByTrains(terminal: TerminalLevel) {
    terminal.showNearByTrains = !terminal.showNearByTrains;
    terminal.showNearByTrains
      ? this.iohActiveTableCount.update(itemsList => [...itemsList, 1])
      : this.iohActiveTableCount.update(itemsList => itemsList.slice(0, -1));
    this.iohActiveTableCount().length != 0
      ? this.iohShowCollapseAllBtn.set(true)
      : this.iohShowCollapseAllBtn.set(false);
    this.generateContextMenuItem();
  }

  //enableling context menu changes
  onContextMenuClick(event: any, iohcm: any) {
    if (!this.iohDeviceDetectorService.checkIsTouchDevice()) {
      iohcm.show(event);
    }
    event.preventDefault();
  }

  //on terminal click event
  terminalClicked(terminal: any) {
    let code =
      terminal.code == 'NOW'
        ? 'NWO'
        : terminal.code == 'PHI'
        ? 'GRE'
        : terminal.code;
    if (!terminal.name.includes('JUNCTION'))
      this.dialogService.showDialog(code);
  }

  //on corridor click event
  iohCorridorClicked(corridorCode: string) {
    const corridorNodes = corridorCode.split('-');
    const forwardCorridorString = `${corridorNodes[0]}${corridorNodes[1]}`;
    const reverseCorridorString = `${corridorNodes[1]}${corridorNodes[0]}`;
    const gisData = sessionStorage.getItem('intermodalBBox');
    const selectedGisData = JSON.parse(gisData).find(gisObj => {
      return (
        gisObj.corridorCode === forwardCorridorString ||
        gisObj.corridorCode === reverseCorridorString
      );
    });
    this.iohMapService.iohZoomToBoundingBox([
      [selectedGisData.x1, selectedGisData.y1],
      [selectedGisData.x2, selectedGisData.y2]
    ]);
    this.iohAppService.iohLevelUpdate$.set(2);
    this.iohLevelLabelChange.emit('level-3');
  }

  //to collapse all opened train tables
  iohCollapseAll() {
    this.iohCollapseAllData.set(true);
    for (const terminal of this.terminals) {
      (terminal.showNearByTrains = false),
        (terminal.showEquipmentInfo = false),
        (terminal.showGateInfo = false);
        (terminal.showTrainInfo = false);
    }
    this.iohShowCollapseAllBtn.set(false);
    this.iohActiveTableCount.set([]);
    this.generateContextMenuItem();
  }

  //to show more train on more label click
  iohMoreCliked(event: number, terminal?: TerminalLevel) {
    if (event === 1) {
      this.iohActiveTableCount.update(itemsList => [...itemsList, event]);
      this.iohShowCollapseAllBtn.set(true);
      this.iohCollapseAllData.set(false);
    } else {
      if (terminal) {
        this.terminals.forEach(ter => {
          if (ter.uid === terminal.uid) ter.showNearByTrains = false;
        });
      }
      this.iohActiveTableCount.update(itemsList => itemsList.slice(0, -1));
      this.iohActiveTableCount().length != 0
        ? this.iohShowCollapseAllBtn.set(true)
        : this.iohShowCollapseAllBtn.set(false);
      this.iohCollapseAllData.set(false);
    }
    this.generateContextMenuItem();
  }

  //to construct context men with levels
  generateContextMenuItem() {
    this.iohItems.set([
      {
        label: 'Collapse All',
        disabled: !this.iohShowCollapseAllBtn() && this.iohLevelLabel() !== 'level-3',
        command: () => {
          this.iohCollapseAll();
        }
      },
      {
        label: 'Level 1',
        disabled: this.iohLevelLabel() === 'level-1',
        command: () => {
          this.iohTerminalChange.emit('');
          this.iohAppService.iohLevelUpdate$.set(0);
          this.iohLevelLabelChange.emit('level-1');
          this.IohFocusOnTrian(true);
        }
      },
      {
        label: 'Level 2',
        disabled: this.iohLevelLabel() === 'level-2',
        command: () => {
          this.iohTerminalChange.emit('');
          this.iohAppService.iohLevelUpdate$.set(1);
          this.iohLevelLabelChange.emit('level-2');
          this.IohFocusOnTrian(true);
        }
      },
      {
        label: 'Map',
        disabled: this.iohLevelLabel() === 'level-3',
        command: () => {
          this.iohAppService.iohLevelUpdate$.set(2);
          this.iohLevelLabelChange.emit('level-3');
          this.IohFocusOnTrian(true);
        }
      }
    ]);
  }

  //to handle zoom level
  handleZoom(operator: string): void {
    if (operator === '+') {
      this.iohZoomLevel.update(zoom => Math.min(zoom + 0.25, 1.5));
    } else if (operator === '-') {
      this.iohZoomLevel.update(zoom =>
        Math.max(zoom - 0.25, this.miniohZoomLevel())
      );
    }
    this.updateFontSize();
    this.cdr.detectChanges();
  }

  //to handle font size based on zoom level
  updateFontSize() {
    let fontSize = null;
    let roundediohZoomLevel = Math.floor(this.iohZoomLevel() * 10) / 10;
    if (this.isTabletView()) {
      if (roundediohZoomLevel > 0.7 && roundediohZoomLevel < 1) {
        fontSize = 11;
      } else {
        fontSize = 12;
      }
      this.iohAppService.iohSetfontSizeValue(fontSize);
    }
  }

  //to focus train on levels
  IohFocusOnTrian(levelSwitched = false) {
    this.messageService.clear();
    if (this.iohTrainIdForSearch()) {
       setTimeout(() => {
      const elementDOMId =
        this.iohTrainIdForSearch()?.toLowerCase() +
        'L' +
        (this.iohLevelLabel().split('-')[1] === '2' ? 1 : 0);
      const elementDOM = document.getElementById(elementDOMId);
      if (elementDOM) {
        elementDOM.scrollIntoView({
          block: 'center',
          inline: 'center'
        });
      } else if (levelSwitched && this.iohLevelLabel() === 'level-2' ) {
        this.messageService.clear();
        this.messageService.add({
          key: 'missingIOHTrain',
          severity: 'info',
          summary: 'Missing Train Id',
          icon: 'pi pi-exclamation-triangle intermodal-custom-error-toast-icon',
          life: 30000,
          detail: `Unable to view '${this.iohTrainIdForSearch()}' on ${this.iohLevelLabel()} due to missing roll up `
        });
      }
      }, 0);
    }
  }

  onLevelChangeEvent(event: string) {
    if (event === 'level-1') {
      this.iohTerminalChange.emit('');
      this.iohAppService.iohLevelUpdate$.set(0);
    } else if (event === 'level-2') {
      this.iohTerminalChange.emit('');
      this.iohAppService.iohLevelUpdate$.set(1);
    } else {
      this.iohAppService.iohLevelUpdate$.set(2);
    }
    this.iohZoomLevel.set(
      event === 'level-1' ? this.defaultiohZoomLevelForLevel1() : 1
    );
    this.iohLevelLabelChange.emit(event);
    this.IohFocusOnTrian(true);
  }

  //on level change
  onLevelChange(event: any) {
    const value = event.option.value;
    if (value === 'level-1') {
      this.iohTerminalChange.emit('');
      this.iohAppService.iohLevelUpdate$.set(0);
    } else if (value === 'level-2') {
      this._iohSelectedTerminal.set('2');
      this.iohTerminalChange.emit('');
      this.iohAppService.iohLevelUpdate$.set(1);
    } else {
      this.iohMapService.iohHideBaseLayer$.next(false);
      this.iohTerminalChange.emit('');
      this.iohAppService.iohLevelUpdate$.set(2);
    }
    this.iohLevelLabelChange.emit(value);
    this.IohFocusOnTrian(true);
  }

  adjustSvgZoom() {
    if (this.defaultiohZoomLevelForLevel1() === 0) {
      var container = document.getElementById('ioh-level-wrapper-id');
      var svgWidth = 1970;
      var svgHeight = 1050;
      var scaleX = container.offsetWidth / svgWidth;
      var scaleY = container.offsetHeight / svgHeight;
      var scale = Math.min(scaleX, scaleY);
      this.iohZoomLevel.set(Number(scale.toFixed(2)));
      if (this.iohZoomLevel() < this.miniohZoomLevel()) {
        this.iohZoomLevel.set(this.miniohZoomLevel());
      }
      if (this.iohZoomLevel() > 1.5) {
        this.iohZoomLevel.set(1.5);
      }
      this.defaultiohZoomLevelForLevel1.set(this.iohZoomLevel());
    }
  }

  onTrainLabelChange() {
    this.iohMapService.iohShowTrainLabels$.next(this.iohTrainLabelsShow());
    this.showIohTrainLabels(true);
  }

  iohHandleTableClose() {
    this.iohTrainIdForSearch.set('');
  }

  //to get equipment info for terminal
  getEquipmentTableInfo(terminal: string) {
    let rawTableResponse = this.iohEquipmentInfo()?.find(item =>
      terminal.toUpperCase().includes(item.terminalName)
    );
    if (rawTableResponse) {
      return this.processEquipmentTableData(rawTableResponse?.assetDetails);
    }
    return null;
  }

  //to process equipment info table data
  processEquipmentTableData(rawTableResponse: any) {
    let totalActiveCount = 0;
    let totalOfflineCount = 0;
    rawTableResponse.forEach(entry => {
      if (entry.vehicleType === 'CHE' || entry.vehicleType === 'WSC_CLIENT') {
        totalActiveCount += entry.activeCount;
        totalOfflineCount += entry.offlineCount;
      }
    });
    return {
      totalActiveCount,
      totalOfflineCount
    };
  }

  private getSchematicPopupBounds(): { left: number; right: number; top: number; bottom: number } | null {
    const rect = this.iohlevelSchematic?.nativeElement?.getBoundingClientRect();
    return rect ? { left: rect.left, right: rect.right, top: rect.top, bottom: rect.bottom } : null;
  }

  //to show equipment info on terminal click
  showEquipmentInfo(terminal: TerminalLevel, event?: MouseEvent) {
    terminal.showEquipmentInfo = !terminal.showEquipmentInfo;
    terminal.popupClickPoint = event ? { x: event.clientX, y: event.clientY } : null;
    terminal.popupBounds = this.getSchematicPopupBounds();
    terminal.showEquipmentInfo
      ? this.iohActiveTableCount.update(itemsList => [...itemsList, 1])
      : this.iohActiveTableCount.update(itemsList => itemsList.slice(0, -1));
    this.iohActiveTableCount().length != 0
      ? this.iohShowCollapseAllBtn.set(true)
      : this.iohShowCollapseAllBtn.set(false);
    this.generateContextMenuItem();
  }

  handleClose(flag){
    this.iohActiveTableCount.update(itemsList => itemsList.slice(0, -1));
    this.iohActiveTableCount().length != 0
      ? this.iohShowCollapseAllBtn.set(true)
      : this.iohShowCollapseAllBtn.set(false);
    this.generateContextMenuItem();
  }

  //to show equipment info on terminal click
  showTrainInfo(terminal: TerminalLevel, event?: MouseEvent) {
    terminal.showTrainInfo = !terminal.showTrainInfo;
    terminal.popupClickPoint = event ? { x: event.clientX, y: event.clientY } : null;
    terminal.popupBounds = this.getSchematicPopupBounds();
    terminal.showTrainInfo
      ? this.iohActiveTableCount.update(itemsList => [...itemsList, 1])
      : this.iohActiveTableCount.update(itemsList => itemsList.slice(0, -1));
    this.iohActiveTableCount().length != 0
      ? this.iohShowCollapseAllBtn.set(true)
      : this.iohShowCollapseAllBtn.set(false);
    this.generateContextMenuItem();
  }

  showGateInfo(terminal: TerminalLevel, event?: MouseEvent) {
    terminal.showGateInfo = !terminal.showGateInfo;
    terminal.popupClickPoint = event ? { x: event.clientX, y: event.clientY } : null;
    terminal.popupBounds = this.getSchematicPopupBounds();
    terminal.showGateInfo
      ? this.iohActiveTableCount.update(itemsList => [...itemsList, 1])
      : this.iohActiveTableCount.update(itemsList => itemsList.slice(0, -1));
    this.iohActiveTableCount().length != 0
      ? this.iohShowCollapseAllBtn.set(true)
      : this.iohShowCollapseAllBtn.set(false);
    this.generateContextMenuItem();
  }

  getTerminalCode(code) {
    return code == 'NOW' ? 'NWO' : code == 'PHI' ? 'GRE' : code;
  }

  isIohJunction(terminal){
    return terminal?.name?.includes('JUNCTION')
  }

  ngOnDestroy(): void {
    this.iohDeviceDetectorService.destroy();
    this.iohMapService.iohShowTrainLabels$.next(false);
    if (this.level === 2) this.iohMapService.registerMapSlot('level3', null);
  }

  ngAfterViewInit(): void {
    if (this.level === 2) {
      this.iohMapService.registerMapSlot('level3', this.level3MapSlot?.nativeElement ?? null);
    }
  }
}
